import { Box, Typography } from "@mui/material";
import React from "react";
import NeoButton from "../NeoButton";
import { useAuthStore } from "../../@shared/store/useAuthStore";
import { MainContext } from "../../App";
import { ArrowForwardIos } from "@mui/icons-material";
import { useTutorial } from "../../@shared/utils/useTutorial";
import TutorialInfinityOrb from "../TutorialInfinityOrb";
import { useDriverTutorial } from "../../@shared/utils/useDriverTutorial";

const IOIntro = () => {
  const { Theme } = React.useContext(MainContext);
  const { userData } = useAuthStore();
  const { progress, sequence, advanceStep } = useTutorial(userData?.id);
  useDriverTutorial(userData?.id);

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: 1000,
      }}
    >
      <Box
        sx={{
          width: "100%",
          height: "100%",
          position: "relative",
          zIndex: 1000,
        }}
      >
        <Box
          sx={{
            position: "absolute",
            left: sequence?.orbPosition.left,
            top: {
              xs: "20%",
              md: sequence?.orbPosition.top,
            },
            transform: `scale(${sequence?.orbPosition.scale})`,
            zIndex: 2001,
          }}
        >
          <TutorialInfinityOrb />
        </Box>

        <Box
          sx={{
            width: { xs: "85%", md: "50%" },
            height: { xs: "40%", md: "30%" },
            position: "absolute",
            left: "50%",
            bottom: "2%",
            transform: "translate(-50%, 0%)",
            zIndex: 1,
            background: "white",
            borderRadius: 2,
            padding: 2,
          }}
        >
          <Box
            sx={{
              width: "100%",
              height: "100%",
              position: "relative",
              alignItems: "center",
              display: "flex",
              flexFlow: "column",
              justifyContent: "center",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                mb: 7,
                whiteSpace: "pre-line",
                width: "100%",
                textAlign: "center",
                position: "relative",
                top: { xs: "45px", md: "0px" },
              }}
            >
              {progress && sequence?.steps?.[progress.currentStepIndex]?.text}
            </Typography>

            <Box
              data-driver="next-button"
              sx={{
                width: "fit-content",
                height: "fit-content",
                position: "absolute",
                top: "0px",
                right: "5px",
              }}
            >
              <NeoButton
                isIcon
                icon={<ArrowForwardIos />}
                color={Theme.palette.tirciary.main}
                onClick={advanceStep}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default IOIntro;
